import Vuex from "vuex";

export default {
  methods: {
    // Profile methods
    async fetch_schema_profiles(sub_section) {
      let params = { sub_section: sub_section };
      var path = this.T.build_path_data(
        this.apip.API_SCHEMA_PROFILES_PATH,
        params
      );
      try {
        var response = await this.pyx_api.get(path);
        return response.data;
      } catch (error) {
        this.show_error_message(error);
        return null;
      }
    },
    async fetch_profile(sub_section) {
      let params = { sub_section: sub_section };
      var path = this.T.build_path_data(
        this.apip.API_PROFILES_PATH + "/mine",
        params
      );
      try {
        var response = await this.pyx_api.get(path);
        return response.data;
      } catch (error) {
        this.show_error_message(error);
        return null;
      }
    },
    async get_and_set_profile_data() {
      let profile = await this.fetch_profile(null);
      if (this.debug) console.log(profile);
      this.set_user_profile(profile);
      return profile;
    },
    async check_for_profile_data(schema_profile, profile) {
      let res = this.T.validate_schema(schema_profile, profile);
      if (!res[0]) this.errors = res[1].errors;
      else this.errors = null;
      this.set_requires_profile_data(this.errors != null);
      if (this.errors != null) {
        if (this.$route.path != "/") this.$router.push("/");
      }
    },
    // Token methods
    calculate_token_alives() {
      let d = new Date(this.user_data.access_token.expiry);
      let timeout = this.debug ? 1000 : 50000;
      let me = this;
      this.check_token_interval = setInterval(() => {
        let now = new Date();
        let diff = d - now;
        this.token_alives = this.T.millis_to_time(diff);
        if (diff <= 50000) {
          me.$refs.login_user.do_logout(`/login`);
        }
      }, timeout);
    },
    check_token_expiry() {
      if (this.user_data?.access_token?.expiry) {
        this.calculate_token_alives();
      }
    },
    // Preferences methods
    fetch_preferences(sub_section = null) {
      let params = {};
      if (sub_section) {
        params = { sub_section: sub_section };
      }
      var path = this.T.build_path_data(
        this.apip.API_PREFERENCES_PATH + "/mine",
        params
      );
      return this.pyx_api.get(path).catch((error) => {
        this.show_error_message(error);
      });
    },
    save_preferences(sub_section, data) {
      let params = { sub_section: sub_section };
      var path = this.T.build_path_data(
        this.apip.API_PREFERENCES_PATH + "/mine",
        params
      );
      return this.pyx_api.post(path, data).catch((error) => {
        this.show_error_message(error);
      });
    },
    async get_and_set_preferences_data() {
      let ret = await this.fetch_preferences();
      if (this.debug) console.log("preferences", ret.data);
      this.set_user_preferences(ret.data);
      return ret.data;
    },
    fetch_pulse_counters() {
      var path = `${this.apip.API_PULSES_COUNTERS_PATH}`;
      return this.pyx_api.get(path).catch((error) => {
        this.show_error_message(error);
      });
    },
    async get_and_set_pulse_counters() {
      let ret = await this.fetch_pulse_counters();
      if (this.debug) console.log("pulse_counters", ret.data);
      this.set_pulse_counters(ret.data);
      return ret.data;
    },
    ...Vuex.mapActions([
      "show_error_message",
      "show_info_message",
      "set_requires_profile_data",
      "system_login",
      "set_user_profile",
      "set_user_preferences",
      "set_pulse_counters",
    ]),
  },
  computed: {
    ...Vuex.mapState([
      "is_login",
      "requires_profile_data",
      "is_ready",
      "user_data",
      "user_preferences",
    ]),
  },
};
